var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar-logo-container", class: { collapse: false } },
    [
      _vm.logo
        ? _c("div", [
            !_vm.collapse
              ? _c(
                  "div",
                  {
                    staticClass: "custom-wrapper",
                    on: {
                      click: function($event) {
                        return _vm.$router.push("/")
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "layering" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "custom-logo" }, [
                      _c("img", {
                        staticStyle: { padding: "10px" },
                        attrs: { alt: "", src: _vm.logoUrl(_vm.logo.logoPath) }
                      })
                    ])
                  ]
                )
              : _c("div", { staticClass: "shrink" }, [
                  _c("img", {
                    staticStyle: { width: "24px" },
                    attrs: {
                      src: require("@/assets/share_images/paycenter-logo.svg")
                    }
                  })
                ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }